import { Mixins, Component } from 'vue-property-decorator';
import api from '@/api/helpQues';
import { ITABLECOLCONF } from '@/types/base.d';
import pageMixin from '../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private mList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '帮助问题',
    prop: 'helpTitle',
    align: 'center',
    tooltip: true,
  }, {
    label: '帮助类别',
    align: 'center',
    prop: 'helpTypeLabel',
  }, {
    label: '创建时间',
    align: 'center',
    custom: true,
    tag: {
      type: 'primary',
      prop: ['createTime'],
    },
  }, {
    label: '更新时间',
    align: 'center',
    custom: true,
    tag: {
      type: 'primary',
      prop: ['createTime'],
    },
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '修改',
        name: '/helpQues:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleOperate,
        log: {
          name: '机构管理 - 操作',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/helpQues:remove',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '机构管理 - 删除',
          component: 'org/manage/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author liangyongmou
   * @desc 获取机构列表
   */
  getData() {
    this.loading = true;
    api.getHelpManual(this.page).then((res: any) => {
      this.mList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 机构操作
   * @param { any } row 行数据
   */
  handleOperate(row: any) {
    this.$router.push({ name: 'helpQues/operate', params: { pid: Base64.encode(row.pid) } });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除机构操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeManual(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '机构管理 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
